import app from 'flarum/forum/app';
import WeeklyQuizPage from './components/WeeklyQuizPage';

app.initializers.add('tf-weekly-quiz', () => {
  // 注册 weekly-quiz 路由
  app.routes['weekly-quiz'] = { path: '/weekly-quiz', component: WeeklyQuizPage };
});

